import { FORM_SLUG_REPORT_SITE_ISSUE, KAPP_SLUG_ERMS } from './constants';

export const getDefaultFormIcon = form =>
  form
    ? form.type === 'Approval'
      ? 'clipboard-check'
      : form.type === 'Action'
        ? 'tasks'
        : 'ticket-alt'
    : 'file';

export const selectReportSiteIssueForm = state =>
  state.app.kapps
    ?.find(k => k.slug === KAPP_SLUG_ERMS)
    ?.forms?.find(f => f.slug === FORM_SLUG_REPORT_SITE_ISSUE);
